/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountCode,
    AccountCodeFromJSON,
    AccountCodeFromJSONTyped,
    AccountCodeToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CardPoolSetting,
    CardPoolSettingFromJSON,
    CardPoolSettingFromJSONTyped,
    CardPoolSettingToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsFormData
 */
export interface VccCredentialsFormData {
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    id?: string | null;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof VccCredentialsFormData
     */
    cardSupplier?: GuidIdAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof VccCredentialsFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<AccountCode>}
     * @memberof VccCredentialsFormData
     */
    accountCodes?: Array<AccountCode> | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    zip?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsFormData
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsFormData
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    agentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    apiKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    consumer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    server?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    organisationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    merchantId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    bankId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsFormData
     */
    companyId?: string | null;
    /**
     * 
     * @type {Array<CardPoolSetting>}
     * @memberof VccCredentialsFormData
     */
    cardPoolSettings?: Array<CardPoolSetting> | null;
}

export function VccCredentialsFormDataFromJSON(json: any): VccCredentialsFormData {
    return VccCredentialsFormDataFromJSONTyped(json, false);
}

export function VccCredentialsFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardSupplier': !exists(json, 'cardSupplier') ? undefined : GuidIdAndLabelFromJSON(json['cardSupplier']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(AccountCodeFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'addressLine1': !exists(json, 'addressLine1') ? undefined : json['addressLine1'],
        'addressLine2': !exists(json, 'addressLine2') ? undefined : json['addressLine2'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'agentId': !exists(json, 'agentId') ? undefined : json['agentId'],
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
        'bookerId': !exists(json, 'bookerId') ? undefined : json['bookerId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'consumer': !exists(json, 'consumer') ? undefined : json['consumer'],
        'server': !exists(json, 'server') ? undefined : json['server'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'merchantId': !exists(json, 'merchantId') ? undefined : json['merchantId'],
        'bankId': !exists(json, 'bankId') ? undefined : json['bankId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'cardPoolSettings': !exists(json, 'cardPoolSettings') ? undefined : (json['cardPoolSettings'] === null ? null : (json['cardPoolSettings'] as Array<any>).map(CardPoolSettingFromJSON)),
    };
}

export function VccCredentialsFormDataToJSON(value?: VccCredentialsFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardSupplier': GuidIdAndLabelToJSON(value.cardSupplier),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(AccountCodeToJSON)),
        'description': value.description,
        'email': value.email,
        'url': value.url,
        'addressLine1': value.addressLine1,
        'addressLine2': value.addressLine2,
        'city': value.city,
        'country': value.country,
        'zip': value.zip,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'agentId': value.agentId,
        'apiKey': value.apiKey,
        'bookerId': value.bookerId,
        'clientId': value.clientId,
        'consumer': value.consumer,
        'server': value.server,
        'username': value.username,
        'organisationId': value.organisationId,
        'merchantId': value.merchantId,
        'bankId': value.bankId,
        'companyId': value.companyId,
        'cardPoolSettings': value.cardPoolSettings === undefined ? undefined : (value.cardPoolSettings === null ? null : (value.cardPoolSettings as Array<any>).map(CardPoolSettingToJSON)),
    };
}


